module.exports = __webpack_public_path__ + "assets/51f2fb4dbab28cac091aa4cb3191317d.png";